module.exports = __webpack_public_path__ + "static/media/cinecash.2f24f267.svg";